import { faLock } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import React from 'react';

import { getRunStatusBadgeStyles, STATUS_LABELS_OVERRIDES } from './_run-header';

export const RunHeaderForSP = ({ run }) => {
  const runStatusBadgeStyles = getRunStatusBadgeStyles(run);

  return (
    <div className="run-header-card card-base">
      <div className='run-header-card__header'>
        <div className="run-header-card__left card-left">
          <div className="run-workstation-body__info info-section">
            <div className="d-flex align-items-center">
              <h5 className='mb0 mr-2'>Status:</h5>
              <span
                className="run-header-card__badge"
                style={runStatusBadgeStyles}
              >
                {STATUS_LABELS_OVERRIDES[run.status]}
              </span>
            </div>
          </div>
          {run.pieces_locked && (
            <div className="run-header-card__badge run-header-card__badge--locked">
              <FontAwesomeIcon icon={faLock} className="run-header-card__badge-icon" />
              LOCKED
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

RunHeaderForSP.propTypes = {
  run: PropTypes.shape({
    uri: PropTypes.string.isRequired,
    // eslint-disable-next-line camelcase
    pieces_locked: PropTypes.bool.isRequired,
    name: PropTypes.string.isRequired,
    status: PropTypes.string.isRequired,
    scheduled: PropTypes.shape({
      start: PropTypes.string,
      end: PropTypes.string,
    }).isRequired,
    prints: PropTypes.arrayOf(PropTypes.string).isRequired,
  }),

};

RunHeaderForSP.defaultProps = {
  run: {},
};